/**
 * Shared <custom-tabs> initializer for mobile nav mattress tabs and
 * find-perfect sections. Always loaded; find-product.js stays conditional.
 */
function customTabsIsMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function customTabsInitHybridGallery(tabsRoot) {
  if (!tabsRoot || !customTabsIsMobile()) return;

  var hybridGallery = tabsRoot.querySelector('.product-gallery-hybrid');
  if (!hybridGallery || hybridGallery.classList.contains('swiper-container-initialized')) return;

  var paginationEl = hybridGallery.querySelector('.swiper-pagination');

  function runInit() {
    if (hybridGallery.classList.contains('swiper-container-initialized')) return;

    var galleryProductHybrid = new Swiper(hybridGallery, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1.15,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product',
        paginationBulletMessage: 'Go to product {{index}}',
        slideLabelMessage: 'Product {{index}} of {{slidesLength}}',
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            '" role="button" tabindex="0" aria-label="Go to product ' +
            (index + 1) +
            '"></span>'
          );
        },
      },
    });

    hybridGallery.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
      slide.addEventListener('focusin', function () {
        galleryProductHybrid.slideTo(i);
      });
    });

    if (typeof galleryProductHybrid.update === 'function') {
      galleryProductHybrid.update();
    }
  }

  if (typeof window.zinusOnSwiperReady === 'function') {
    window.zinusOnSwiperReady(runInit);
  } else if (typeof Swiper !== 'undefined') {
    runInit();
  }
}

class CustomTabs extends HTMLElement {
  constructor() {
    super();
    this.tablist = this.querySelector('.tablist');
    this.tabs = this.querySelectorAll('.tab-item:not([disabled="true"])');
    this.tabsRoot = this.closest('.zinus-perfect-product');
    this.tabpanels = this.tabsRoot ? this.tabsRoot.querySelectorAll('.tabpanel') : [];
    this.selectPreviousTab = this.selectPreviousTab.bind(this);
    this.selectNextTab = this.selectNextTab.bind(this);
    this.selectFirstTab = this.selectFirstTab.bind(this);
    this.selectLastTab = this.selectLastTab.bind(this);
    this.selectTab = this.selectTab.bind(this);

    if (!this.tablist || !this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        let selectedButton = e.target.closest('button');
        let nextTabIndex = Array.prototype.slice.call(this.tabs).indexOf(selectedButton);
        this.selectTab(nextTabIndex);
      });
    });

    this.tablist.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowLeft':
          this.selectPreviousTab();
          break;
        case 'ArrowRight':
          this.selectNextTab();
          break;
        case 'Home':
          e.preventDefault();
          this.selectFirstTab();
          break;
        case 'End':
          e.preventDefault();
          this.selectLastTab();
          break;
      }
    });
  }

  selectPreviousTab() {
    var activeTab = this.querySelector('.tab-item[aria-selected="true"]');
    var activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);

    if (activeTabIndex > 0) {
      this.selectTab(activeTabIndex - 1);
    } else {
      this.selectTab(this.tabs.length - 1);
    }
  }

  selectNextTab() {
    var activeTab = this.querySelector('.tab-item[aria-selected="true"]');
    var activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);
    if (activeTabIndex < this.tabs.length - 1) {
      this.selectTab(activeTabIndex + 1);
    } else {
      this.selectTab(0);
    }
  }

  selectFirstTab() {
    this.selectTab(0);
  }

  selectLastTab() {
    this.selectTab(this.tabs.length - 1);
  }

  selectTab(index) {
    if (index < 0 || !this.tabs[index]) return;

    this.tabs.forEach(function (tab) {
      tab.setAttribute('aria-selected', false);
      tab.setAttribute('tabindex', -1);
    });

    this.tabs[index].setAttribute('aria-selected', true);
    this.tabs[index].setAttribute('tabindex', 0);
    this.tabs[index].focus();

    this.tabpanels.forEach(function (tabpanel) {
      tabpanel.classList.remove('is-visible');
    });

    const tabsRoot = this.tabsRoot || this.closest('.zinus-perfect-product');
    const panelId = this.tabs[index].getAttribute('aria-controls');
    const nextTabpanel = tabsRoot && panelId ? tabsRoot.querySelector('#' + panelId) : null;
    if (nextTabpanel) {
      nextTabpanel.classList.add('is-visible');
    }

    let selectedValue = (this.tabs[index].dataset.value || '').toLowerCase();
    if (selectedValue === 'hybrid' && this.classList.contains('enable-swiper__slider') && tabsRoot) {
      customTabsInitHybridGallery(tabsRoot);
    }
  }
}

if (!customElements.get('custom-tabs')) {
  customElements.define('custom-tabs', CustomTabs);
}
